export default __webpack_public_path__ + "static/media/CapaCircle.7addd8e7.svg";